import { bindActionCreators, Dispatch } from 'redux';
import { connect, RootStateOrAny } from 'react-redux';
import { RouteComponentProps } from 'react-router';

import moment from 'moment';
import { Typography } from 'antd';

import { isEmailAddressValid } from 'utils/helpers';

import { update } from 'store/app/userProfile/actions';
import UserProfile from 'components/UserProfile';

import './index.scss';

const { Title } = Typography;

type UserProfilePageProps = RouteComponentProps<any> & {
  update(userModel: Object): any,
  isUpdating: boolean,
};

const UserProfilePage = (props: UserProfilePageProps) => {
  const IS_SIX_MONTH_DIFF = moment().diff(moment(sessionStorage.getItem('modified_date')), 'months', true) > 6 ? true : false;
  const EMAIL = isEmailAddressValid(sessionStorage.getItem('email'));

  return (
    <div className="user-profile-page">
      <div className="header-title">
        <Title level={4} className="ml-3" style={{'marginTop': IS_SIX_MONTH_DIFF || !EMAIL ? '1.1em' : ''}}>User Profile</Title>
      </div>
      <div>
        <UserProfile
          update={props.update}
          isUpdating={props.isUpdating}
        />
      </div>
    </div>
  )
};

const mapStateToProps = (store: RootStateOrAny) => ({
  isUpdating: store.rootReducer.appUserProfile.isUpdating,
});

const mapDispatchToProps = (dispatch: Dispatch) => bindActionCreators(
  {
    update,
  },
  dispatch,
);

export default connect(mapStateToProps, mapDispatchToProps)(UserProfilePage);